'use strict';

var PRIVATE = 'private';
var PASSWORD_PROTECTED = 'password_protected';
var PUBLIC = 'public';
var MEMBERS_ONLY = 'members_only';
var ORGWIDE = 'organization_wide';
var SECRET = 'secret';
var CAN_READ = 'can_read';
var CAN_WRITE = 'can_write';
var CAN_EDIT = 'can_edit';
var CAN_ADMINISTER = 'can_administer';
var PERMISSION_TO_INTEGER = {};
PERMISSION_TO_INTEGER[CAN_READ] = 1;
PERMISSION_TO_INTEGER[CAN_WRITE] = 2;
PERMISSION_TO_INTEGER[CAN_EDIT] = 4;
PERMISSION_TO_INTEGER[CAN_ADMINISTER] = 8;
var INTEGER_TO_PERMISSION = {};
INTEGER_TO_PERMISSION[1] = CAN_READ;
INTEGER_TO_PERMISSION[2] = CAN_WRITE;
INTEGER_TO_PERMISSION[4] = CAN_EDIT;
INTEGER_TO_PERMISSION[8] = CAN_ADMINISTER;

var permissionToNumberLookup = function permissionToNumberLookup(canDoSomething) {
  return PERMISSION_TO_INTEGER[canDoSomething] || 0;
};

var numberToPermissionLookup = function numberToPermissionLookup(permissionAsNumber) {
  return INTEGER_TO_PERMISSION[permissionAsNumber] || null;
};

module.exports = {
  PRIVATE: PRIVATE,
  PASSWORD_PROTECTED: PASSWORD_PROTECTED,
  PUBLIC: PUBLIC,
  SECRET: SECRET,
  MEMBERS_ONLY: MEMBERS_ONLY,
  ORGWIDE: ORGWIDE,
  CAN_READ: CAN_READ,
  CAN_WRITE: CAN_WRITE,
  CAN_EDIT: CAN_EDIT,
  CAN_ADMINISTER: CAN_ADMINISTER,
  permissionToNumberLookup: permissionToNumberLookup,
  numberToPermissionLookup: numberToPermissionLookup
};